import React from 'react';
import { Select } from 'antd';
import { ApprovalsOrganizationBusinessOption } from '@approvals/graphql';

type Props = {
  options?: ApprovalsOrganizationBusinessOption[];
  value: string;
  onChange: (value: string) => void;
};

export const ApprovalsPageLocationSelect = ({
  options,
  value,
  onChange,
}: Props) => {
  return (
    <>
      <div className="approvals-page-location-select-container">
        <label className="approvals-page-location-select-label">
          Select facility
        </label>
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            !!option?.label.toLowerCase().includes(input.toLowerCase())
          }
          placeholder="Choose location"
          value={value}
          onChange={onChange}
          className="approvals-page-location-select"
          options={options?.map((item) => ({
            value: item.id,
            label: item.name,
          }))}
          size="large"
        ></Select>
      </div>
      <style jsx>
        {`
          :global(.approvals-page-location-select) {
            width: 400px;
          }
          .approvals-page-location-select-container {
            width: 580px;
          }
          .approvals-page-location-select-label {
            display: block;
            margin-left: 1px;
          }
        `}
      </style>
    </>
  );
};
